import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { connect } from 'react-redux';
import { Spin, Card } from 'antd';
import { Row, Col } from 'antd';
class Charts extends React.Component {
    getOption1 = data => {
        // debugger
        // console.log(data);
        let title = '分时新增IP比率图';
        // data = data.reverse();
        // console.log(data)
        const dateList = data.map(function(item) {
            return item.time;
        });
        const reqList = data.map(function(item) {
            return item.ratio;
        });

        const option = {
            legend: {
                data: ['新增IP比率'],
            },
            title: [
                {
                    text: title,
                    subtext: '比率',
                },
            ],
            tooltip: {
                trigger: 'axis',
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: dateList,
                },
            ],
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}',
                },
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                },
                {
                    start: 0,
                    end: 10,
                    handleIcon:
                        'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                },
            ],
            series: [
                {
                    name: '新增IP比率',
                    type: 'line',
                    smooth: false,
                    symbol: 'none',
                    sampling: 'average',
                    markLine: {},
                    data: reqList,
                    // lineStyle: {
                    //     normal: {
                    //         color: '#1890ff', // 连线颜色
                    //     },
                    // },
                },
            ],
        };

        return option;
    };
    getOption2(data) {
        const dateList = data.map(function(item) {
            return item.time;
        });
        const totalR = data.map(function(item) {
            return item.totalErrorR;
        });
        const clickR = data.map(function(item) {
            return item.clickErrorR;
        });
        const evR = data.map(function(item) {
            return item.evErrorR;
        });
        const option = {
            legend: {
                data: ['总失败率', '点击失败率', '曝光失败率'],
            },
            title: [
                {
                    text: 'IP失败率',
                    subtext: '失败率',
                },
            ],
            tooltip: {
                trigger: 'axis',
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: dateList,
                },
            ],
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}',
                },
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                },
                {
                    start: 0,
                    end: 10,
                    handleIcon:
                        'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                },
            ],
            series: [
                {
                    name: '总失败率',
                    type: 'line',
                    smooth: false,
                    symbol: 'none',
                    sampling: 'average',
                    markLine: {},
                    data: totalR,
                    // lineStyle: {
                    //     normal: {
                    //         color: '#1890ff', // 连线颜色
                    //     },
                    // },
                },
                {
                    name: '点击失败率',
                    type: 'line',
                    smooth: false,
                    symbol: 'none',
                    sampling: 'average',
                    markLine: {},
                    data: clickR,
                    // lineStyle: {
                    //     normal: {
                    //         color: '#1890ff', // 连线颜色
                    //     },
                    // },
                },
                {
                    name: '曝光失败率',
                    type: 'line',
                    smooth: false,
                    symbol: 'none',
                    sampling: 'average',
                    markLine: {},
                    data: evR,
                    // lineStyle: {
                    //     normal: {
                    //         color: '#1890ff', // 连线颜色
                    //     },
                    // },
                },
            ],
        };

        return option;
    }

    render() {
        const { isShowEchart, charts } = this.props;
        return (
            <Spin spinning={isShowEchart} tip="加载中...">
                <Row>
                    <Col span={12}>
                        <div style={{ height: '300px', margin: '0 0 20px 0' }}>
                            <ReactEcharts ref="echarts_react" option={this.getOption1.bind(this)(charts)} />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ height: '300px', margin: '0 0 20px 0' }}>
                            <ReactEcharts ref="echarts_react" option={this.getOption2.bind(this)(charts)} />
                        </div>
                    </Col>
                </Row>
            </Spin>
        );
    }
}

const mapStateToProps = state => ({
    charts: state.agencyAnalysis.proxyinfo,
    isShowEchart: state.agencyAnalysis.uiStatus.isLoading,
});

export default connect(mapStateToProps, null)(Charts);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/agencyAnalysis/echarts.js